<template>
<div  :style="fontstyle">
    <slot></slot>
    <div class='rate' @mouseout="mouseOut">
      <span @mouseover="mouseOver(num)"  v-for='num in len' :key="num">☆</span>
      <span class='hollow' :style="{width:styleObject.width,transitiontransition:styleObject.transition}">
        <span @click="onRate(num)" @mouseover="mouseOver(num)" v-for='num in len' :key="num">★</span>
      </span>
    </div>
</div>
</template>
<script>
export default {
  name: 'Rate',
  data: function () {
    const themeObj = {
      'black': '#00',
      'white': '#fff',
      'red': '#f5222d',
      'orange': '#fa541c',
      'yellow': '#fadb14',
      'green': '#73d13d',
      'blue': '#40a9ff',
      'purple': '#9254de'
    }
    return {
      styleObject: {
        width: this.score * 13 + 'px',
        transition: `width ${this.animate}s`
      },
      i: 1,
      styleFont: {
        color: themeObj[this.theme] ? themeObj[this.theme] : this.theme,
        fontSize: this.size ? this.size : ''
      }
    }
  },
  computed: {
    fontstyle () {
      return `color:${this.styleFont.color};font-size:${this.styleFont.fontSize}`
    },
    len () {
      return parseInt(this.length)
    }
  },
  props: {
    score: {type: [Number, String], default: '0'},
    length: {type: [Number, String], default: '5'},
    animate: {type: [Number, String], default: '1'},
    theme: {type: [String], default: 'yellow'},
    size: {type: [String]},
    readonly: {type: [Boolean], defalut: false}
  },
  methods: {
    setStyle: function () {
      this.styleObject = {
        width: this.score * 13 + 'px',
        transition: `width ${this.animate}s`
      }
    },
    mouseOver (i) {
      if (this.readonly) {
        return false
      }
      this.styleObject.width = i * 13 + 'px'
      this.$emit('getScore', i)
    },
    mouseOut () {
      this.styleObject.width = this.score * 13 + 'px'
    },
    onRate (i) {
      if (this.readonly) {
        return false
      }
      this.$emit('getScore', i)
    }
  },
  mounted: function () {
    if (this.animate === '0' || this.animate === 0) {
      this.setStyle()
    } else {
      setTimeout(() => {
        this.setStyle()
      }, 500)
    }
  }
}
</script>

<style scoped>
.rate{
  position:relative;
  display: inline-block;
}
.rate > span.hollow {
  position:absolute;
  display: inline-block;
  top:0;
  left:0;
  width:0;
  overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Rate.vue